import React from 'react'

interface Props {
  label: string
  value: string
}

export const LineData = ({ label, value }: Props): JSX.Element => {
  return (
    <tr className="relative bg-white border-b [border-bottom-style:solid] border-gray-300">
      <td
        className="pt-1 w-1/3"
        style={{
          backgroundImage:
            'linear-gradient(to bottom, rgb(243 244 246/var(--tw-bg-opacity)) 0%, rgb(243 244 246/var(--tw-bg-opacity)) 100%), linear-gradient(to bottom, #fff 0%, #fff 100%)',
          backgroundClip: 'content-box, padding-box',
        }}
      >
        <div className="px-3 py-2 font-bold">{label}</div>
      </td>

      <td className="pt-1">
        <div className="px-3 py-2">{value}</div>
      </td>
    </tr>
  )
}
